import { HEROES } from '@fukemon/shared';
import { useGameStore } from '../state/gameStore';
import { PanelShell } from './PanelShell';

export function VaultPanel() {
  const selected = useGameStore((state) => state.selectedHero);
  const selectHero = useGameStore((state) => state.selectHero);
  const xp = useGameStore((state) => state.xp);
  const active = HEROES.find((hero) => hero.id === selected)!;
  const unlocked = new Set(['cuntmander', 'dickachu', 'blowmesaur']);

  return (
    <PanelShell eyebrow="SOULBOUND PROFILE // LEVEL 6" title="FUKÉVAULT" wide>
      <div className="vault-layout">
        <div className="card-preview">
          <img src={active.cardImage} alt={`${active.name} Fukecard`} />
          <div className="card-preview__shine" />
        </div>
        <div className="vault-copy">
          <span className="type-pill" style={{ background: active.color }}>
            {active.type}
          </span>
          <h3>{active.name}</h3>
          <p>{active.description}</p>
          <div className="ability-box">
            <span>FUKABILITY</span>
            <strong>{active.ability}</strong>
            <p>{active.abilityText}</p>
          </div>
          <div className="xp-row">
            <span>RAGE-UP PROGRESS</span>
            <strong>{xp} / 250 XP</strong>
          </div>
          <div className="xp-track">
            <span style={{ width: `${Math.min(100, (xp / 250) * 100)}%` }} />
          </div>
        </div>
      </div>
      <h3 className="section-label">ACTIVE DISASTER</h3>
      <div className="hero-roster">
        {HEROES.map((hero) => {
          const available = unlocked.has(hero.id);
          return (
            <button
              key={hero.id}
              disabled={!available}
              className={selected === hero.id ? 'hero-chip hero-chip--active' : 'hero-chip'}
              onClick={() => available && selectHero(hero.id)}
            >
              <span style={{ background: hero.color }}>{hero.name.slice(0, 1)}</span>
              <strong>{hero.name}</strong>
              <small>{available ? hero.ability : hero.unlock}</small>
            </button>
          );
        })}
      </div>
    </PanelShell>
  );
}

